/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum LeasingActivityColumns {
    OCCUPANCY_OVER_TIME_AT_DATE = 'occupancy_over_time_at_date',
    LEASED_PERCENTAGE = 'leased_percentage',
    EXPOSURE_PERCENTAGE = 'exposure_percentage',
}
